function pickRandomTrials(listTrials,listType,listRandom,listRandomBlock,listRandomPick)
{
  var flagsStart = [];
  var flagsEnd = [];
  var listRandomAll = [];
  var tempUpperLimit;

for (var i = 0; i < listTrials.length; i++){listRandomAll[i] = listType[i]+listRandomBlock[i]+listRandom[i];}

for (var i = 0; i < listTrials.length; i++)
{
  //in case first trial should be randomised
  if (i == 0 && listRandomPick[i] != "na"){flagsStart.push(i);}
  //for all trials except last
  if (i != listTrials.length-1)
  {
    if (listRandomPick[i]!=listRandomPick[i+1])
    {
      if (listRandomPick[i]=="na")
      {
        flagsStart.push(i+1);
      }
      else if (listRandomPick[i+1]=="na")
      {
        flagsEnd.push(i);
      }
      else
      {
        flagsStart.push(i+1);
        flagsEnd.push(i);
      }
    }
    else if (listRandomPick[i]!="na" && listRandomAll[i]!=listRandomAll[i+1])
    {
      console.log('i:'+i);
      flagsStart.push(i+1);
      flagsEnd.push(i);
    }
  }
  //in case last trial should be randomised
  if (i == listTrials.length-1 && listRandomPick[i] != "na"){flagsEnd.push(i);}
}

  console.log('flagsStart:'+flagsStart);
  console.log('flagsEnd:'+flagsEnd);
  ////create new stimOrder
  var stimOrder = [];
  //trials before first flag
  for (var i = 0; i < flagsStart[0]; i++)
  {
    stimOrder.push(listTrials[i]);
  }
  //trials between flags
  for (var j = 0; j < flagsStart.length; j++)
  {
    nTrialsPickGroup = flagsEnd[j] - flagsStart[j] + 1;
    nTrialsToPick = listRandomPick[flagsStart[j]];
    randomSubset = randperm(nTrialsPickGroup);

    if (nTrialsToPick < nTrialsPickGroup)
    {
      for (var i = 0; i < nTrialsToPick; i++)
      {
        stimOrder.push(listTrials[flagsStart[j]+randomSubset[i]]);
      }
    }
    else
    {
      for (var i = flagsStart[j]; i < flagsEnd[j]+1; i++)
      {
        stimOrder.push(listTrials[i]);
      }
    }
  //trials after last flag
  if (j==flagsStart.length-1){tempUpperLimit=listTrials.length;}else{tempUpperLimit=flagsStart[j+1];}
  for (var i = flagsEnd[j]+1; i < tempUpperLimit; i++)
  {
    stimOrder.push(listTrials[i]);
  }
}
  return stimOrder;

}

function pickRandomTrialsWithRandomGroup(listTrials,listRandomPick,listRandomGroup, listRandom, listRandomBlock, listType, listTrialTimerLabels){
  var trialsSeperatedByGroups = {}
  var randomPickCountForGroups = []
  var newStimOrder = []
  var groupList = getImplicitRandomGroups(listTrials,listRandomPick,listRandomGroup, listRandom, listRandomBlock, listType, listTrialTimerLabels);
  for(var i = 0; i < listTrials.length; i++){
    var currentRandomGroup = groupList[i];
    if(currentRandomGroup != "na"){
      if(trialsSeperatedByGroups[currentRandomGroup] == undefined){
        trialsSeperatedByGroups[currentRandomGroup] = [];
        randomPickCountForGroups[currentRandomGroup] = listRandomPick[i]
      }
      trialsSeperatedByGroups[currentRandomGroup].push(listTrials[i]);
    }
  }
  //prepare the newStimOrder in which we keep the original position of trials that need not to be randomized and/or random picked
  for(var i = 0; i < listTrials.length; i++){
    if(listRandomPick[i] == "na"){
      newStimOrder.push(listTrials[i]);
    }
    else{
      var currentRandomGroup = groupList[i];
      var currentRandomPick = (listRandomPick[i] < trialsSeperatedByGroups[currentRandomGroup].length) ? listRandomPick[i] : trialsSeperatedByGroups[currentRandomGroup].length;
      for(var j = 0; j < currentRandomPick; j++){
        newStimOrder.push("na");
      }
      while(groupList[i+1] == currentRandomGroup){
        i++;
      }
    }
  }

  //Go through each group of trials
  var generatedRandomTrials = [];
  for(var i in trialsSeperatedByGroups){
    if(trialsSeperatedByGroups[i]){
      var currentGroup = trialsSeperatedByGroups[i];
      //Pick randomPick trials for the group
      for(var j = 0; j < randomPickCountForGroups[i]; j++){
        if(currentGroup.length <= 0){
          break;
        }
        var randomTrialIndex = getRandomInteger(0, currentGroup.length - 1);
        generatedRandomTrials.push(currentGroup[randomTrialIndex]);
        currentGroup.splice(randomTrialIndex, 1);
      }
    }
  }

  var newListRandom = [];
  var newListBlocks = [];

  for(var i in newStimOrder){
    if(newStimOrder[i] == "na"){
      newStimOrder[i] = generatedRandomTrials.shift();
    }
    newListRandom[i] = columnForTrial('random',newStimOrder[i]);
    newListBlocks[i] = columnForTrial('randomBlock', newStimOrder[i]);
  }

  console.log('listBlocks', listRandomBlock, newListBlocks);

  if (!(allTheSame(newListRandom) && newListRandom[0]=='na'))
  {
    console.log('stimOrder before random within blocks', newStimOrder);
    newStimOrder = randomizeWithinBlocks(newStimOrder, newListRandom, listRandomBlock, listTrialTimerLabels);
    console.log('stimOrder after random within blocks', newStimOrder);
  }
  if (!(allTheSame(listRandomBlock) && listRandomBlock[0]=='na'))
  {
    console.log('stimOrder before randomize blocks', newStimOrder);
    newStimOrder = randomizeBlocks(newStimOrder,newListBlocks)
    console.log('stimOrder after randomize blocks', newStimOrder);
  }
  return newStimOrder;
}

function randomizePickedTrialsBlocks(newStimOrder) {
  var newListBlocks = [];

  for(var i in newStimOrder){
    newListBlocks[i] = columnForTrial('randomBlock', newStimOrder[i]);
  }


  if (!(allTheSame(newListBlocks) && newListBlocks[0]=='na'))
  {
    console.log('stimOrder before randomize blocks', newStimOrder);
    newStimOrder = randomizeBlocks(newStimOrder, newListBlocks)
    console.log('stimOrder after randomize blocks', newStimOrder);
  }
  return newStimOrder;
}

function getImplicitRandomGroups(listTrials,listRandomPick,listRandomGroup, listRandom, listRandomBlock, listType, listTrialTimerLabels){
  var currentGroup, prevGroup="na", groupIndex = -1;
  var groupList = [];

  for(var i in listTrials){
    currentGroup = listType[i]+listRandomPick[i]+listRandomBlock[i]+listRandom[i]+listRandomGroup[i]+listTrialTimerLabels[i];
    if(currentGroup != prevGroup){
      groupIndex++;
    }
    groupList.push(groupIndex);
    prevGroup = currentGroup;
  }
  return groupList;
}
